'use client';

/** /future — Control Room v4: chrome + five-deck shell (P2) + surfaces (P3+). */
import { Chrome } from '@/future/chrome/Chrome';
import { Shell } from '@/future/shell/Shell';

export default function FuturePage() {
  return (
    <Chrome>
      <Shell />
    </Chrome>
  );
}
